export const IMPORTACAO_TIPOS = [
    'clientes',
    'fornecedores',
    'transportadores',
    'produtos',
    'contasreceber',
    'contaspagar',
] as const;

export type ImportacaoTipo = (typeof IMPORTACAO_TIPOS)[number];
